import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Settings gear — slow continuous rotation around the icon centre.
 *  8-spoked cogwheel drawn as a polygon so the stroke stays at a
 *  consistent 1.5px across all teeth. */
export function IcnGear(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="gear">
      <g style={{ transformOrigin: '8px 8px' }}>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0"
            to="360"
            dur="6s"
            repeatCount="indefinite"
          />
        )}
        {/* 8-tooth cog — 16×16 centred */}
        <path d="M8 1.5 v2 M8 12.5 v2 M1.5 8 h2 M12.5 8 h2 M3.4 3.4 l1.4 1.4 M11.2 11.2 l1.4 1.4 M3.4 12.6 l1.4 -1.4 M11.2 4.8 l1.4 -1.4" />
        <circle cx="8" cy="8" r="4" />
        <circle cx="8" cy="8" r="1.5" />
      </g>
    </Svg>
  );
}
